import { Button, IconButton } from '@mui/material'
import React, { useEffect, useRef } from 'react'
import { useLocation, useNavigate, useParams} from 'react-router-dom'
import { useAppDispatch } from '../../../State/Store';

import { Celebration } from '@mui/icons-material';
import { red } from '@mui/material/colors';

import { verifySeller } from '../../../State/seller/sellerSlice';
export const VerifySeller = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const location = useLocation();
      const { otp } = useParams<{ otp: string }>();

    // Persistent State Across Renders:

// The value of useRef persists across renders, which means even if the component re-renders, the value remains unchanged unless explicitly modified.
// In this case, calledOnce is a ref initialized to false. It will remain false until it’s explicitly set to true.
// No Re-render Trigger:

// Unlike useState, updating a useRef value does not cause a re-render. When calledOnce.current is set to true, it prevents subsequent calls to handleDispatchPaymentHandler without affecting the component’s render cycle.
// Safe Execution Guard:

// The check if (!calledOnce.current) ensures that the handler is called only on the first execution of useEffect. Subsequent renders will skip this block as calledOnce.current will already be true.

    const calledOnce = useRef(false); // Ref to ensure single execution

    const getQueryParam = (key:string) => { 
        const query = new URLSearchParams(location.search)
        return query.get(key);
     }
     
     
      useEffect(() => {
        
        if (!otp) {
            console.log("No otp in URL");
            return;
          }
          console.log("Dispatch verifySeller with otp:", otp);
          dispatch(verifySeller(otp));
        
      }, [otp,dispatch]); // Dependency on `paymentId`
     
  return (
    <div className='min-h-[90vh] flex justify-center items-center'>
        <div className="bg-primary text-white p-8 w-[90%] lg:w-[30%] border-rounded-md h-[40vh] flex flex-col gap-7 items-center justify-center">
            
            <h1 className='text-3xl font-semibold'>
            <span>
                    <IconButton sx={{color:red[400]}} >
                        <Celebration sx={{fontSize:"3rem"}}/>
                    </IconButton>
                </span>
                Congratulations!
               
            </h1>
            <h1 className='text-2xl font-semibold'>Your Account Has Been Activated Successfully </h1>
            <div className="">
                <Button color='secondary' variant='contained' onClick={() => { navigate("/seller/add-product") }}>
                   Create Product
                </Button>
            </div>
        </div>
    </div>
  )
}
